import React from 'react';

const DJPalProgressBar = ({ visible }) => {
    if (!visible) return null;

    return (
        <div className="djpal-progress-bar">
            <div className="progress-fill" />
        </div>
    );
};

export default DJPalProgressBar;
